<div class="so-stepper-container" [class.so-stepper--horizontal]="isHorizontal()"
    [class.so-stepper--vertical]="isVertical()"
    [class.so-stepper--compact]="compact()"
    [class.so-stepper--pill]="isPill()">
    <div class="so-stepper-wrapper">
        @for (item of steps(); track item.route; let last = $last; let i = $index) {
        <div class="so-stepper-item" [class.so-stepper-item--completed]="item.status === 'completed'"
            [class.so-stepper-item--active]="item.status === 'active'"
            [class.so-stepper-item--pending]="item.status === 'pending'"
            [class.so-stepper-item--clickable]="!isStepNavigationDisabled(i)"
            [class.so-stepper-item--disabled]="isStepNavigationDisabled(i)"
            [matTooltip]="stepTooltip(item, i)"
            [attr.aria-label]="isPill() ? item.text : null"
            (click)="navigateToStep(item.route, i)">

            <!-- Step Circle -->
            <div class="so-stepper-circle" [class.so-stepper-circle--completed]="item.status === 'completed'"
                [class.so-stepper-circle--active]="item.status === 'active'"
                [class.so-stepper-circle--pending]="item.status === 'pending'">
                @if (item.status === 'completed') {
                <mat-icon class="so-stepper-circle-icon">check</mat-icon>
                } @else {
                <span class="so-stepper-circle-number">{{ i + 1 }}</span>
                }
            </div>

            <!-- Step Content -->
            <div class="so-stepper-content">
                <span class="so-stepper-title">{{ item.text }}</span>
                <so-badge-ui [text]="getBadgeText(item)" [color]="getBadgeColor(item)" [size]="'xs'">
                </so-badge-ui>
            </div>
        </div>

        <!-- Connector Line -->
        @if (!last) {
        <div class="so-stepper-line" [class.so-stepper-line--active]="steps()[i + 1].status !== 'pending'">
        </div>
        }
        }
    </div>
</div>